export const rootPixelFontSize = 16;
export const pxToRem = (px) => px / rootPixelFontSize;
//# sourceMappingURL=px-to-rem.js.map
